module.exports = __webpack_public_path__ + "fonts/Open_Sans-400-hebrew5.daafcec.woff2";